module.exports = __webpack_public_path__ + "img/searx.png";